import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import FormCheckbox from "../../../components/form/FormCheckbox";
import ModalCheckboxGrid from "../../../components/modal/ModalCheckboxGrid";
import ModalDescription from "../../../components/modal/ModalDescription";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import { REFERENCE_RELATES_TO } from "../../../constants/references";
import { referenceOperations } from "../../../modules/definition/references";
import { typeOperations } from "../../../modules/definition/types";
import settingsSelectors from "../../settingsModal/selectors";

const renderDescription = _useProps => {
  return (
    <ModalRow key="description">
      <ModalDescription>
        <span>
          Aeon Timeline now supports multiple event types, and event-to-event/entity-to-entity relationships. You can
          enable these new data types to build a more complete picture of your data.
        </span>
      </ModalDescription>
    </ModalRow>
  );
};

const renderOptions = useProps => {
  const eventTypes = settingsSelectors.eventTypesFromAllTypes(useProps.types);
  const personTypes = settingsSelectors.personTypesFromAllTypes(useProps.types);

  const onTypeChange = (id, enabled) => useProps.dispatchLocal(typeOperations.changeEnabled(id, enabled));

  const eventCheckboxes = eventTypes
    .map(t => (
      <FormCheckbox
        key={t.id}
        label={t.label}
        checkboxState={t.enabled}
        onChange={state => onTypeChange(t.id, state)}
        disabled={t.id === useProps.defaultSequenceType}
      />
    ))
    .toArray();

  const eventToPersonReferences = settingsSelectors.eventToPersonReferences(
    useProps.references,
    eventTypes,
    personTypes
  );
  const eventToEventReferences = settingsSelectors
    .eventToEventReferences(useProps.references, eventTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));
  const personToPersonReferences = settingsSelectors
    .personToPersonReferences(useProps.references, personTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));

  const onReferenceChange = (ids, enabled) => useProps.dispatchLocal(referenceOperations.changeEnabled(ids, enabled));

  const eventToEventState = !eventToEventReferences.find(r => !r.enabled);
  const personToPersonState = !personToPersonReferences.find(r => !r.enabled);

  const showPersonToPerson = personToPersonReferences.size > 0;
  const showEventToEvent = eventToEventReferences.size > 0;

  const otherCheckboxes = [
    showEventToEvent ? (
      <div>
        <FormCheckbox
          key="eventToEvent"
          label="Event-to-event relationships"
          checkboxState={eventToEventState}
          onChange={state =>
            onReferenceChange(
              eventToEventReferences
                .map(r => r.id)
                .filter(id => id !== REFERENCE_RELATES_TO)
                .toList()
                .toArray(),
              state
            )
          }
        />
        <ModalDescription>
          <div style={{ paddingLeft: "1.3em" }}>
            {eventToEventReferences.map((ref, index) => (
              <span key={ref.id}>
                {index > 0 ? ", " : ""}
                {ref.label}
              </span>
            ))}
          </div>
        </ModalDescription>
      </div>
    ) : null,
    showPersonToPerson ? (
      <div>
        <FormCheckbox
          key="personToPerson"
          label="Entity-to-entity relationships"
          checkboxState={personToPersonState}
          onChange={state =>
            onReferenceChange(
              personToPersonReferences
                .map(r => r.id)
                .filter(id => id !== REFERENCE_RELATES_TO)
                .toList()
                .toArray(),
              state
            )
          }
        />
        <ModalDescription>
          <div style={{ paddingLeft: "1.3em" }}>
            {personToPersonReferences.map((ref, index) => (
              <span key={ref.id}>
                {index > 0 ? ", " : ""}
                {ref.label}
              </span>
            ))}
          </div>
        </ModalDescription>
      </div>
    ) : null
  ];

  const otherItemsLabel = showPersonToPerson || showEventToEvent ? "Relationships" : " ";

  return (
    <ModalRow>
      <ModalField label="Event Types" flex={1}>
        <ModalCheckboxGrid columns={1}>{eventCheckboxes}</ModalCheckboxGrid>
      </ModalField>
      <ModalField label={otherItemsLabel}>
        <ModalCheckboxGrid columns={1}>{otherCheckboxes}</ModalCheckboxGrid>
      </ModalField>
    </ModalRow>
  );
};

const CustomizeDataPage = props => {
  return [
    <ModalGroup key="content">
      {renderDescription(props)}
      {renderOptions(props)}
    </ModalGroup>
  ];
};

CustomizeDataPage.propTypes = {
  types: ImmutablePropTypes.list.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  properties: ImmutablePropTypes.list.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired
};

export default CustomizeDataPage;
